export const QUESTIONS = [
  {
    "id": 1,
    "text": "I get stressed out easily.",
    "factor": "N",
    "facet": "Anxiety",
    "keyed": 1
  },
  {
    "id": 2,
    "text": "I am relaxed most of the time.",
    "factor": "N",
    "facet": "Anxiety",
    "keyed": -1
  },
  {
    "id": 3,
    "text": "I worry about things.",
    "factor": "N",
    "facet": "Anxiety",
    "keyed": 1
  },
  {
    "id": 4,
    "text": "I seldom feel blue.",
    "factor": "N",
    "facet": "Depression",
    "keyed": -1
  },
  {
    "id": 5,
    "text": "I am easily disturbed.",
    "factor": "N",
    "facet": "Vulnerability",
    "keyed": 1
  },
  {
    "id": 6,
    "text": "I feel comfortable with myself.",
    "factor": "N",
    "facet": "Depression",
    "keyed": -1
  },
  {
    "id": 7,
    "text": "I get irritated easily.",
    "factor": "N",
    "facet": "Anger",
    "keyed": 1
  },
  {
    "id": 8,
    "text": "I often feel blue.",
    "factor": "N",
    "facet": "Depression",
    "keyed": 1
  },
  {
    "id": 9,
    "text": "I get upset easily.",
    "factor": "N",
    "facet": "Anger",
    "keyed": 1
  },
  {
    "id": 10,
    "text": "I rarely get irritated.",
    "factor": "N",
    "facet": "Anger",
    "keyed": -1
  },
  {
    "id": 11,
    "text": "I am not easily bothered by things.",
    "factor": "N",
    "facet": "Vulnerability",
    "keyed": -1
  },
  {
    "id": 12,
    "text": "I change my mood a lot.",
    "factor": "N",
    "facet": "Anxiety",
    "keyed": 1
  },
  {
    "id": 13,
    "text": "I have frequent mood swings.",
    "factor": "N",
    "facet": "Anxiety",
    "keyed": 1
  },
  {
    "id": 14,
    "text": "I get overwhelmed by emotions.",
    "factor": "N",
    "facet": "Vulnerability",
    "keyed": 1
  },
  {
    "id": 15,
    "text": "I remain calm under pressure.",
    "factor": "N",
    "facet": "Vulnerability",
    "keyed": -1
  },
  {
    "id": 16,
    "text": "I am a person whose moods go up and down easily.",
    "factor": "N",
    "facet": "Anxiety",
    "keyed": 1
  },
  {
    "id": 17,
    "text": "I feel threatened easily.",
    "factor": "N",
    "facet": "Self-Consciousness",
    "keyed": 1
  },
  {
    "id": 18,
    "text": "I am not embarrassed easily.",
    "factor": "N",
    "facet": "Self-Consciousness",
    "keyed": -1
  },
  {
    "id": 19,
    "text": "I feel others are better than me.",
    "factor": "N",
    "facet": "Self-Consciousness",
    "keyed": 1
  },
  {
    "id": 20,
    "text": "I am not easily bothered by criticism.",
    "factor": "N",
    "facet": "Self-Consciousness",
    "keyed": -1
  },
  {
    "id": 21,
    "text": "I am hard to satisfy.",
    "factor": "N",
    "facet": "Immoderation",
    "keyed": 1
  },
  {
    "id": 22,
    "text": "I am content with my lot in life.",
    "factor": "N",
    "facet": "Immoderation",
    "keyed": -1
  },
  {
    "id": 23,
    "text": "I panic easily.",
    "factor": "N",
    "facet": "Vulnerability",
    "keyed": 1
  },
  {
    "id": 24,
    "text": "I am not easily frustrated.",
    "factor": "N",
    "facet": "Vulnerability",
    "keyed": -1
  },
  {
    "id": 25,
    "text": "I am the life of the party.",
    "factor": "E",
    "facet": "Gregariousness",
    "keyed": 1
  },
  {
    "id": 26,
    "text": "I do not talk a lot.",
    "factor": "E",
    "facet": "Gregariousness",
    "keyed": -1
  },
  {
    "id": 27,
    "text": "I feel comfortable around people.",
    "factor": "E",
    "facet": "Friendliness",
    "keyed": 1
  },
  {
    "id": 28,
    "text": "I keep in the background.",
    "factor": "E",
    "facet": "Gregariousness",
    "keyed": -1
  },
  {
    "id": 29,
    "text": "I start conversations.",
    "factor": "E",
    "facet": "Friendliness",
    "keyed": 1
  },
  {
    "id": 30,
    "text": "I have little to say.",
    "factor": "E",
    "facet": "Friendliness",
    "keyed": -1
  },
  {
    "id": 31,
    "text": "I talk to a lot of different people at parties.",
    "factor": "E",
    "facet": "Gregariousness",
    "keyed": 1
  },
  {
    "id": 32,
    "text": "I do not like to draw attention to myself.",
    "factor": "E",
    "facet": "Assertiveness",
    "keyed": -1
  },
  {
    "id": 33,
    "text": "I do not mind being the centre of attention.",
    "factor": "E",
    "facet": "Assertiveness",
    "keyed": 1
  },
  {
    "id": 34,
    "text": "I am quiet around strangers.",
    "factor": "E",
    "facet": "Friendliness",
    "keyed": -1
  },
  {
    "id": 35,
    "text": "I make friends easily.",
    "factor": "E",
    "facet": "Friendliness",
    "keyed": 1
  },
  {
    "id": 36,
    "text": "I would describe my experiences as somewhat dull.",
    "factor": "E",
    "facet": "Excitement-Seeking",
    "keyed": -1
  },
  {
    "id": 37,
    "text": "I take charge.",
    "factor": "E",
    "facet": "Assertiveness",
    "keyed": 1
  },
  {
    "id": 38,
    "text": "I wait for others to lead the way.",
    "factor": "E",
    "facet": "Assertiveness",
    "keyed": -1
  },
  {
    "id": 39,
    "text": "I know how to captivate people.",
    "factor": "E",
    "facet": "Assertiveness",
    "keyed": 1
  },
  {
    "id": 40,
    "text": "I find it difficult to approach others.",
    "factor": "E",
    "facet": "Friendliness",
    "keyed": -1
  },
  {
    "id": 41,
    "text": "I am always busy.",
    "factor": "E",
    "facet": "Activity Level",
    "keyed": 1
  },
  {
    "id": 42,
    "text": "I like to take it easy.",
    "factor": "E",
    "facet": "Activity Level",
    "keyed": -1
  },
  {
    "id": 43,
    "text": "I love excitement.",
    "factor": "E",
    "facet": "Excitement-Seeking",
    "keyed": 1
  },
  {
    "id": 44,
    "text": "I prefer to be alone.",
    "factor": "E",
    "facet": "Gregariousness",
    "keyed": -1
  },
  {
    "id": 45,
    "text": "I show my feelings readily.",
    "factor": "E",
    "facet": "Cheerfulness",
    "keyed": 1
  },
  {
    "id": 46,
    "text": "I am hard to get to know.",
    "factor": "E",
    "facet": "Cheerfulness",
    "keyed": -1
  },
  {
    "id": 47,
    "text": "I have a lot of fun.",
    "factor": "E",
    "facet": "Cheerfulness",
    "keyed": 1
  },
  {
    "id": 48,
    "text": "I often feel like I do not have enough energy.",
    "factor": "E",
    "facet": "Activity Level",
    "keyed": -1
  },
  {
    "id": 49,
    "text": "I have a rich vocabulary.",
    "factor": "O",
    "facet": "Intellect",
    "keyed": 1
  },
  {
    "id": 50,
    "text": "I have difficulty understanding abstract ideas.",
    "factor": "O",
    "facet": "Intellect",
    "keyed": -1
  },
  {
    "id": 51,
    "text": "I have a vivid imagination.",
    "factor": "O",
    "facet": "Imagination",
    "keyed": 1
  },
  {
    "id": 52,
    "text": "I am not interested in abstract ideas.",
    "factor": "O",
    "facet": "Intellect",
    "keyed": -1
  },
  {
    "id": 53,
    "text": "I have excellent ideas.",
    "factor": "O",
    "facet": "Intellect",
    "keyed": 1
  },
  {
    "id": 54,
    "text": "I do not have a good imagination.",
    "factor": "O",
    "facet": "Imagination",
    "keyed": -1
  },
  {
    "id": 55,
    "text": "I am quick to understand things.",
    "factor": "O",
    "facet": "Intellect",
    "keyed": 1
  },
  {
    "id": 56,
    "text": "I use difficult words.",
    "factor": "O",
    "facet": "Intellect",
    "keyed": 1
  },
  {
    "id": 57,
    "text": "I spend time reflecting on things.",
    "factor": "O",
    "facet": "Emotionality",
    "keyed": 1
  },
  {
    "id": 58,
    "text": "I am full of ideas.",
    "factor": "O",
    "facet": "Imagination",
    "keyed": 1
  },
  {
    "id": 59,
    "text": "I find philosophical discussions boring.",
    "factor": "O",
    "facet": "Intellect",
    "keyed": -1
  },
  {
    "id": 60,
    "text": "I get excited by new ideas.",
    "factor": "O",
    "facet": "Intellect",
    "keyed": 1
  },
  {
    "id": 61,
    "text": "I enjoy hearing new ideas.",
    "factor": "O",
    "facet": "Adventurousness",
    "keyed": 1
  },
  {
    "id": 62,
    "text": "I prefer variety to routine.",
    "factor": "O",
    "facet": "Adventurousness",
    "keyed": 1
  },
  {
    "id": 63,
    "text": "I believe in the importance of art.",
    "factor": "O",
    "facet": "Artistic Interests",
    "keyed": 1
  },
  {
    "id": 64,
    "text": "I do not like art.",
    "factor": "O",
    "facet": "Artistic Interests",
    "keyed": -1
  },
  {
    "id": 65,
    "text": "I love to read challenging material.",
    "factor": "O",
    "facet": "Intellect",
    "keyed": 1
  },
  {
    "id": 66,
    "text": "I avoid difficult reading material.",
    "factor": "O",
    "facet": "Intellect",
    "keyed": -1
  },
  {
    "id": 67,
    "text": "I carry the conversation to a higher level.",
    "factor": "O",
    "facet": "Intellect",
    "keyed": 1
  },
  {
    "id": 68,
    "text": "I tend to vote for conservative political candidates.",
    "factor": "O",
    "facet": "Liberalism",
    "keyed": -1
  },
  {
    "id": 69,
    "text": "I enjoy wild flights of fantasy.",
    "factor": "O",
    "facet": "Imagination",
    "keyed": 1
  },
  {
    "id": 70,
    "text": "I tend to stick to conventional ways of doing things.",
    "factor": "O",
    "facet": "Adventurousness",
    "keyed": -1
  },
  {
    "id": 71,
    "text": "I see beauty in things that others might not notice.",
    "factor": "O",
    "facet": "Artistic Interests",
    "keyed": 1
  },
  {
    "id": 72,
    "text": "I have a limited range of interests.",
    "factor": "O",
    "facet": "Adventurousness",
    "keyed": -1
  },
  {
    "id": 73,
    "text": "I feel concern for others.",
    "factor": "A",
    "facet": "Sympathy",
    "keyed": 1
  },
  {
    "id": 74,
    "text": "I am not really interested in others.",
    "factor": "A",
    "facet": "Sympathy",
    "keyed": -1
  },
  {
    "id": 75,
    "text": "I insult people.",
    "factor": "A",
    "facet": "Morality",
    "keyed": -1
  },
  {
    "id": 76,
    "text": "I sympathise with others feelings.",
    "factor": "A",
    "facet": "Sympathy",
    "keyed": 1
  },
  {
    "id": 77,
    "text": "I am not interested in other peoples problems.",
    "factor": "A",
    "facet": "Sympathy",
    "keyed": -1
  },
  {
    "id": 78,
    "text": "I have a soft heart.",
    "factor": "A",
    "facet": "Sympathy",
    "keyed": 1
  },
  {
    "id": 79,
    "text": "I am not really interested in helping people.",
    "factor": "A",
    "facet": "Altruism",
    "keyed": -1
  },
  {
    "id": 80,
    "text": "I take time out for others.",
    "factor": "A",
    "facet": "Altruism",
    "keyed": 1
  },
  {
    "id": 81,
    "text": "I feel others emotions.",
    "factor": "A",
    "facet": "Sympathy",
    "keyed": 1
  },
  {
    "id": 82,
    "text": "I make people feel at ease.",
    "factor": "A",
    "facet": "Altruism",
    "keyed": 1
  },
  {
    "id": 83,
    "text": "I am indifferent to the feelings of others.",
    "factor": "A",
    "facet": "Sympathy",
    "keyed": -1
  },
  {
    "id": 84,
    "text": "I am on good terms with nearly everyone.",
    "factor": "A",
    "facet": "Trust",
    "keyed": 1
  },
  {
    "id": 85,
    "text": "I get back at others.",
    "factor": "A",
    "facet": "Morality",
    "keyed": -1
  },
  {
    "id": 86,
    "text": "I believe that others have good intentions.",
    "factor": "A",
    "facet": "Trust",
    "keyed": 1
  },
  {
    "id": 87,
    "text": "I try to avoid making people feel bad.",
    "factor": "A",
    "facet": "Cooperation",
    "keyed": 1
  },
  {
    "id": 88,
    "text": "I get along well with others.",
    "factor": "A",
    "facet": "Trust",
    "keyed": 1
  },
  {
    "id": 89,
    "text": "I have a good word for everyone.",
    "factor": "A",
    "facet": "Altruism",
    "keyed": 1
  },
  {
    "id": 90,
    "text": "I hold a grudge.",
    "factor": "A",
    "facet": "Morality",
    "keyed": -1
  },
  {
    "id": 91,
    "text": "I am demanding in my interactions with others.",
    "factor": "A",
    "facet": "Cooperation",
    "keyed": -1
  },
  {
    "id": 92,
    "text": "I trust others.",
    "factor": "A",
    "facet": "Trust",
    "keyed": 1
  },
  {
    "id": 93,
    "text": "I believe in an eye for an eye.",
    "factor": "A",
    "facet": "Morality",
    "keyed": -1
  },
  {
    "id": 94,
    "text": "I think that all will be well.",
    "factor": "A",
    "facet": "Trust",
    "keyed": 1
  },
  {
    "id": 95,
    "text": "I rarely put people under pressure.",
    "factor": "A",
    "facet": "Cooperation",
    "keyed": 1
  },
  {
    "id": 96,
    "text": "I feel little concern for others.",
    "factor": "A",
    "facet": "Sympathy",
    "keyed": -1
  },
  {
    "id": 97,
    "text": "I am always prepared.",
    "factor": "C",
    "facet": "Orderliness",
    "keyed": 1
  },
  {
    "id": 98,
    "text": "I leave my belongings around.",
    "factor": "C",
    "facet": "Orderliness",
    "keyed": -1
  },
  {
    "id": 99,
    "text": "I pay attention to details.",
    "factor": "C",
    "facet": "Orderliness",
    "keyed": 1
  },
  {
    "id": 100,
    "text": "I make a mess of things.",
    "factor": "C",
    "facet": "Self-Efficacy",
    "keyed": -1
  },
  {
    "id": 101,
    "text": "I get chores done right away.",
    "factor": "C",
    "facet": "Self-Discipline",
    "keyed": 1
  },
  {
    "id": 102,
    "text": "I often forget to put things back in their proper place.",
    "factor": "C",
    "facet": "Orderliness",
    "keyed": -1
  },
  {
    "id": 103,
    "text": "I like order.",
    "factor": "C",
    "facet": "Orderliness",
    "keyed": 1
  },
  {
    "id": 104,
    "text": "I shirk my duties.",
    "factor": "C",
    "facet": "Dutifulness",
    "keyed": -1
  },
  {
    "id": 105,
    "text": "I follow a schedule.",
    "factor": "C",
    "facet": "Self-Discipline",
    "keyed": 1
  },
  {
    "id": 106,
    "text": "I am exacting in my work.",
    "factor": "C",
    "facet": "Achievement-Striving",
    "keyed": 1
  },
  {
    "id": 107,
    "text": "I do just enough work to get by.",
    "factor": "C",
    "facet": "Achievement-Striving",
    "keyed": -1
  },
  {
    "id": 108,
    "text": "I know how to get things done.",
    "factor": "C",
    "facet": "Self-Efficacy",
    "keyed": 1
  },
  {
    "id": 109,
    "text": "I complete tasks successfully.",
    "factor": "C",
    "facet": "Self-Efficacy",
    "keyed": 1
  },
  {
    "id": 110,
    "text": "I waste my time.",
    "factor": "C",
    "facet": "Self-Discipline",
    "keyed": -1
  },
  {
    "id": 111,
    "text": "I excel in what I do.",
    "factor": "C",
    "facet": "Achievement-Striving",
    "keyed": 1
  },
  {
    "id": 112,
    "text": "I do things in a half-way manner.",
    "factor": "C",
    "facet": "Dutifulness",
    "keyed": -1
  },
  {
    "id": 113,
    "text": "I stick to my chosen path.",
    "factor": "C",
    "facet": "Cautiousness",
    "keyed": 1
  },
  {
    "id": 114,
    "text": "I jump into things without thinking.",
    "factor": "C",
    "facet": "Cautiousness",
    "keyed": -1
  },
  {
    "id": 115,
    "text": "I make rash decisions.",
    "factor": "C",
    "facet": "Cautiousness",
    "keyed": -1
  },
  {
    "id": 116,
    "text": "I rush into things.",
    "factor": "C",
    "facet": "Cautiousness",
    "keyed": -1
  },
  {
    "id": 117,
    "text": "I act without thinking.",
    "factor": "C",
    "facet": "Cautiousness",
    "keyed": -1
  },
  {
    "id": 118,
    "text": "I do things by the book.",
    "factor": "C",
    "facet": "Dutifulness",
    "keyed": 1
  },
  {
    "id": 119,
    "text": "I find it easy to resist temptation.",
    "factor": "C",
    "facet": "Self-Discipline",
    "keyed": 1
  },
  {
    "id": 120,
    "text": "I am always on time.",
    "factor": "C",
    "facet": "Dutifulness",
    "keyed": 1
  }
];
export const QUESTIONS_PER_PAGE = 20;
export const TOTAL_PAGES = Math.ceil(QUESTIONS.length / QUESTIONS_PER_PAGE);
